import fieldDefaultValue from '../components/FormRenderer/FieldWrapper/field-default-value'
import settings from '../settings'
import omit from 'ramda/src/omit'
import { fieldSubTypes } from './types'
import isNil from 'ramda/src/isNil'

const { sessionStorageInitialDataKey } = settings

// fields: Object -> slug: string
const generateEmptyDefaultValues = (fields) => {
  // default value for checkbox & multi_select & file
  // NOTE: never memoize initial values, this mistake took me 2 days and
  // at least a thousand "WTF"s to fix (with git bisect)
  let defaultValues = {}
  Object.keys(fields).forEach((field) => {
    defaultValues = {
      ...defaultValues,
      [field]: fieldDefaultValue(fields[field].type, fields[field]),
    }
  })
  return defaultValues
}

const getInitialValuesFromField = (formFields = {}) => {
  const fieldsWithoutDefault = [fieldSubTypes.variable.formula]

  return Object.keys(formFields).reduce((acc, slug) => {
    const fieldType = formFields[slug]?.sub_type || formFields[slug].type
    const defaultValue = fieldsWithoutDefault.includes(fieldType)
      ? ''
      : isNil(formFields[slug]?.default)
      ? fieldDefaultValue(fieldType, formFields[slug])
      : formFields[slug]?.default
    return { ...acc, [slug]: defaultValue }
  }, {})
}

export const getInitialValues = (formFields = {}) => {
  const defaultValuesFromFieldsSettings = getInitialValuesFromField(formFields)
  const storageValues = sessionStorage.getItem(sessionStorageInitialDataKey)
  const initialValuesByStorage = storageValues ? JSON.parse(storageValues) : {}

  const finalInitialValues = {
    ...defaultValuesFromFieldsSettings,
    ...initialValuesByStorage,
  }
  // exclude fields with non-empty default values
  const emptyFieldsInitialValues = generateEmptyDefaultValues(
    omit(Object.keys(finalInitialValues), formFields)
  )
  return {
    ...finalInitialValues,
    ...emptyFieldsInitialValues,
  }
}

export const setInitialValues = (item) => {
  sessionStorage.setItem(sessionStorageInitialDataKey, JSON.stringify(item))
}

export const removeInitialValues = () => {
  sessionStorage.removeItem(sessionStorageInitialDataKey)
}
